
import { defineComponent, ref } from "vue";

import FormComponent from "@/components/form/FormComponent.vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import "vue3-date-time-picker/dist/main.css";
import FormToolbar from "@/layout/toolbar/FormToolbar.vue";
import { Actions } from "@/store/enums/StoreEnums";
export default defineComponent({
  name: "DynamicEntityForm",
  components: {
    FormComponent,
    FormToolbar,
  },
  setup() {
    const formComponent = ref(null) as any;
    const route = useRoute();
    const store = useStore();
    store.dispatch(Actions.SET_IS_FROM_LIST, {
      key: route.meta.key,
      flag: false,
    });
    const submitFormAction = () => {
      
      if (formComponent.value) {
        
        formComponent.value.submitButton.click();
        
      }
    };
    return { route, formComponent, submitFormAction };
  },
});
